import React from "react";
import "./Error.css";
import { Typography } from "@anchor/react-components/dist/lib/components";
function Error({ code, title, message, onRetry, retrying = false }) {
  return (
    <div className="error-container" role="alert">
      <Typography className="error-heading" variant="h1">
        {code}
      </Typography>
      {title && (
        <Typography className="error-title" variant="h4">
          {title}
        </Typography>
      )}
      <Typography variant="body1" fontStyle="bold">
        {message}
      </Typography>
      {onRetry && (
        <button
          type="button"
          className="error-retry-button"
          disabled={retrying}
          onClick={() => onRetry()}
        >
          {retrying ? "Trying again..." : "Try again"}
        </button>
      )}
    </div>
  );
}

export default Error;
